import permissions from "../../data/permissions";
import quotation from "./quotation";
export default {
    path: "/sales",
    component: () =>
        import(
            "../../layouts/SalesLayout.vue"
        ),
    meta: { requiresAuth: true },
    children: [
        ...quotation,
        {
            path: "sales-dashboard",
            name: "Sales",
            component: () =>
                import(
                    "../../views/Sales/SalesDashboard.vue"
                ),
            meta: { requiresAuth: true },
        },
        {
            path: "customers",
            name: "Customers",
            component: () =>
                import(
                    "../../views/Sales/Customers.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.customer.read },
        },
        {
            path: "blanket-sales-orders",
            name: "SalesOrders",
            component: () =>
                import(
                    "../../views/Sales/SalesOrders.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_order.read },
        },
        {
            path: "cast-types",
            name: "CastTypes",
            component: () =>
                import(
                    "../../views/Sales/CastTypes.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.cast_type.read }
        },
        {
            path: "payments",
            name: "Payments",
            component: () =>
                import(
                   "../../views/Sales/Payments.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.customer_payment.read }
        },
        {
            path: "payment/:id",
            name: "CustomerPaymentDisplay",
            component: () =>
                import(
                   "../../views/Sales/CustomerPaymentDisplayView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.customer_payment.read }
        },
        {
            path: "customer-statement",
            name: "CustomerStatement",
            component: () =>
                import(
                    "../../views/Sales/CustomerStatementView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.customer_statement },
        },
        {
            path: "invoices",
            name: "Invoices",
            component: () =>
                import(
                    "../../views/Sales/Invoices.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_invoice.read }
        },
        {
            path: "invoice/:id",
            name: "CustomerInvoiceDisplay",
            component: () =>
                import(
                    "../../views/Sales/CustomerInvoiceDisplayView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_invoice.read }
        },
        {
            path: "payment-collection-report",
            name: "PaymentCollectionReport",
            component: () =>
                import(
                    "../../views/Sales/PaymentCollectionReport.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.customers_collection_details }
        },
        {
            path: "credit-notes",
            name: "CreditNotes",
            component: () =>
                import(
                    "../../views/Sales/CreditNotes.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_credit_note.read }
        },
        {
            path: "credit-note/:id",
            name: "SalesCreditNoteDisplay",
            component: () =>
                import(
                    "../../views/Sales/CreditNoteDisplayView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_credit_note.read }
        },
        {
            path: "debit-notes",
            name: "DebitNotes",
            component: () =>
                import(
                    "../../views/Sales/DebitNotes.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_debit_note.read }
        },
        {
            path: "debit-note/:id",
            name: "SalesDebitNoteDisplay",
            component: () =>
                import(
                "../../views/Sales/DebitNoteDisplayView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_debit_note.read }
        },
        {
            path: "activities",
            name: "Activities",
            component: () =>
                import(
                    "../../views/Sales/CustomerActivities.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.customer_activities.read }
        },
        {
            path: "scheduling",
            component: () =>
                import(
                    "../../views/Sales/Scheduling.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.sales_scheduling.read } ,
            props: (route) => ({
                initialDate: route.query.date,
                initialType: route.query.type,
            }),
        },
        {
            path: "scheduling/report",
            component: () =>
                import(
                    "../../views/Sales/SchedulingReport.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.sales_scheduling },
            props: (route) => ({ date: route.query.date }),
        },
        {
            path: "casting-report",
            name: "CastingReport",
            component: () =>
                import(
                    "../../views/Sales/CastingReportPage.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.sales_by_item_details }
        },
        {
            path: "/sales/customers-balance-report",
            name: "CustomersBalanceReport",
            component: () => import('../../views/Sales/CustomersBalanceReportView.vue'),
            meta: { requiresAuth: true, authorization: permissions.report.customers_summary },
        },
        {
            path: "sales-by-item-report",
            name: "SalesByItemReport",
            component: () =>
                import(
                    "../../views/Sales/SalesByItemReportView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.sales_by_item_summary },
        },
        {
            path: "invoice-item-breakdown",
            name: "InvoiceItemBreakdown",
            component: () =>
                import(
                    "../../views/Sales/invoiceItemBreakdown.vue"
                ),
            props: true,
            meta: { requiresAuth: true, authorization: permissions.report.sales_by_item_summary }
        },
        {
            path: "agreement-item-breakdown",
            name: "AgreementItemBreakdown",
            component: () =>
                import(
                    "../../views/Sales/agreementItemBreakdown.vue"
                ),
            props: true,
            meta: { requiresAuth: true, authorization: permissions.report.sales_by_item_summary }
        },
        {
            path: "payment-details-report",
            name: "PaymentDetailsReport",
            component: () =>
                import(
                    "../../views/Sales/PaymentDetailsReportView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.customers_payment_details },
        },
        {
            path: "sales-orders-report",
            name: "SalesOrdersReport",
            component: () =>
                import(
                    "../../views/Sales/SalesOrdersReportView.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.sales_agreements_summary },
        },
        {
            path: "blanket-sales_agreement-validity-report",
            name: "BSA Validity Report",
            component: () =>
                import(
                    "../../views/Sales/SalesOrderValidityReportPage.vue"
                ),
            meta: { requiresAuth: true, authorization: permissions.report.sales_agreement_validity }
        },
        {
            path: "unearned-revenue-report",
            name: "UnearnedRevenueReport",
            component: () => import("./../../views/Sales/UnearnedRevenueView.vue"),
            meta: { requiresAuth: true, authorization: permissions.report.unearned_revenue }
        },
        {
            path: "branches",
            name: "BranchesList",
            component: () => import("./../../views/Sales/BranchesListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_branch.index }
        },
        {
            path: "branch",
            name: "BranchCreate",
            component: () => import("./../../views/Sales/BranchCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_branch.create }
        },
        {
            path: "branch/:id",
            name: "BranchDisplay",
            component: () => import("./../../views/Sales/BranchDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_branch.read }
        },
        {
            path: "branch/:id/edit",
            name: "BranchEdit",
            component: () => import("./../../views/Sales/BranchEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_branch.update }
        },
        {
            path: "sales-persons",
            name: "SalesPersonsList",
            component: () => import("./../../views/Sales/SalesPersonListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_person.index }
        },
        {
            path: "sales-person",
            name: "SalesPersonCreate",
            component: () => import("./../../views/Sales/SalesPersonCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_person.create }
        },
        {
            path: "sales-person/:id",
            name: "SalesPersonDisplay",
            component: () => import("./../../views/Sales/SalesPersonDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_person.read }
        },
        {
            path: "sales-person/:id/edit",
            name: "SalesPersonEdit",
            component: () => import("./../../views/Sales/SalesPersonEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_person.update }
        },
        {
            path: "dashboard",
            name: "SalesDashboard",
            component: () => import("./../../views/Sales/Dashboard.vue"),
            meta: { requiresAuth: true, authorization: permissions.sales_dashboard.all }
        },
    ],
}